module.exports = __webpack_public_path__ + "static/media/Nate-Fagrey.1636f3de.jpg";